import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OilStoreService } from 'services/openapi';

export const useDeleteOilStoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => OilStoreService.oilStoreControllerDelete(id),
  });
};
